module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/holaillustrations-avatar-e0a4260e2788201d8fa2a258e01a38fc.jpg";